import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles';
import { authStateSelector, AUTH_STATE_KEY } from '../../auth-reducer';
import { RBHButton, RBHBox, RBHText, RBHImage, RBHTextInput, RBHTextPasswordInput } from '../../../shared/components';
import { Form } from 'antd';
import { Checkbox } from 'antd';
import { CommonValidator, httpCreators } from 'rbh-merchant-core';
import { AuthHelper } from '../../auth-helper';
import { authSagas } from '../../auth-saga';
import { AUTH_REQUEST_ID_LIST, COGNITO_CHALLENGE } from '../../auth-constant';
import commonStyle from '../../../shared/theme/common-style';
import { Fonts, Images } from '../../../shared/theme';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../shared/components/rbh-text/styles';

export const SignInScreen: React.FC<Props> = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const [redirectToReferrer, setRedirectToReferrer] = React.useState({ staus: false, pathname: '' });
  const [formInvalid, setFormInvalid] = React.useState(true);
  const authStatus = useSelector(authStateSelector(AUTH_STATE_KEY.STATUS));

  React.useEffect(() => {
    switch (authStatus) {
      case COGNITO_CHALLENGE.LOGIN_SUCCESS:
        setRedirectToReferrer({ staus: true, pathname: '/main' });
        break;
      case COGNITO_CHALLENGE.NEW_PASSWORD_REQUIRED:
        history.push('/resetpassword');
        break;
    }
  }, [authStatus]);

  const onFinish = (values: any) => {
    dispatch(httpCreators.request({
      service: AuthHelper.login,
      serviceParams: { email: values.email, password: values.password, remember: values.remember },
      id: AUTH_REQUEST_ID_LIST.LOGIN,
      sagaHandler: authSagas.loginHandler
    }));
  };

  const checkFormInvalid = () => {
    const values = form.getFieldsValue();
    const emailField = values.email || '';
    const passwordField = values.password || '';

    if (emailField.length && passwordField.length) {
      const errors = form.getFieldsError();
      setFormInvalid(false);
      for (const field of errors) {
        if (field.errors.length > 0) {
          setFormInvalid(true);
          break;
        }
      }
    } else {
      setFormInvalid(true);
    }
  };

  if (redirectToReferrer.staus) {
    const { from } = { from: { pathname: redirectToReferrer.pathname } };
    return <Redirect to={from} />;
  }
  return (
    <RBHBox style={styles.default}>
      <RBHBox style={styles.loginBox}>
        <RBHBox style={styles.iconBox}>
          <RBHImage style={styles.iconImage} src={Images.logoIcon} />
        </RBHBox>
        <RBHBox style={commonStyle.paddingTopLarge}>
          <RBHText style={Fonts.style.headerFakeBlack}>
            <FormattedMessage id={'main.login.title'} />
          </RBHText>
        </RBHBox>
        <RBHBox style={commonStyle.paddingTopLarge}>
          <Form form={form} name='normal_login' style={styleText.formText}
            onFieldsChange={checkFormInvalid} onFinish={onFinish}>
            <Form.Item label={<FormattedMessage id={'main.login.email.title'} />} name='email' colon={false}
              rules={[
                {
                  pattern: CommonValidator.Email.regexPattern,
                  message: <FormattedMessage id={'main.login.email.format.valid'} />
                }
              ]}
              validateTrigger={['onChange', 'onBlur']}>
              <RBHTextInput id={'id-email'} autoComplete='off' placeholder={'main.login.email.placeholder'} />
            </Form.Item>

            <Form.Item label={<FormattedMessage id={'main.login.password.title'} />} name='password' colon={false}>
              <RBHTextPasswordInput id={'id-password'} type='password'
                placeholder={'main.login.password.placeholder'} maxLength={CommonValidator.Password.maxLength} />
            </Form.Item>
            <RBHBox style={styles.flexContent}>
              <Form.Item name='remember' valuePropName='checked'>
                <Checkbox id={'id-remember-me'}>
                  <FormattedMessage id={'main.login.rememberme'} />
                </Checkbox>
              </Form.Item>
              <RBHText style={styles.textInner} onClick={() => { history.push('/forgotpassword'); }}>
                <FormattedMessage id={'main.login.forgotpassword'} />
              </RBHText>
            </RBHBox>
            <RBHButton id={'id-submit'} style={styles.buttonBox} disabled={formInvalid} type='primary' htmlType='submit' >
              <FormattedMessage id={'main.login.submit'} />
            </RBHButton>
          </Form>
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {

};
